import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Progress16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_427)'>
      <path
        d='M14.25 8C14.25 4.54822 11.4517 1.75 7.99996 1.75C7.58159 1.75 7.17354 1.791 6.77938 1.86898L6.48828 0.397497C6.9778 0.300655 7.48334 0.25 7.99996 0.25C12.2802 0.25 15.75 3.71979 15.75 8C15.75 12.2802 12.2802 15.75 7.99996 15.75C7.48334 15.75 6.9778 15.6993 6.48828 15.6025L6.77938 14.131C7.17355 14.209 7.58159 14.25 7.99996 14.25C11.4517 14.25 14.25 11.4518 14.25 8Z'
        fill='currentColor'
      />
      <path
        d='M3.69341 14.4442C2.84859 13.8786 2.12138 13.1514 1.55578 12.3066L2.80223 11.4721C3.25875 12.154 3.846 12.7412 4.52789 13.1977L3.69341 14.4442Z'
        fill='currentColor'
      />
      <path
        d='M1.55578 3.69345C2.12138 2.84863 2.84859 2.12141 3.69341 1.55582L4.52789 2.80227C3.846 3.25879 3.25875 3.84604 2.80223 4.52793L1.55578 3.69345Z'
        fill='currentColor'
      />
      <path
        d='M0.39746 9.51169C0.203776 8.53265 0.203776 7.46736 0.39746 6.48832L1.86894 6.77942C1.71299 7.56775 1.71299 8.43225 1.86894 9.22058L0.39746 9.51169Z'
        fill='currentColor'
      />
      <path
        d='M6.99997 11.0605L11.5606 6.49988L10.5 5.43922L6.99997 8.93921L5.49997 7.43921L4.43931 8.49987L6.99997 11.0605Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_427'>
        <rect
          width='16'
          height='16'
          fill='white'
          transform='matrix(0 1 -1 0 16 0)'
        />
      </clipPath>
    </defs>
  </Svg>
);

Progress16.displayName = 'Progress16';
export default Progress16;
